const fitnessHeader = document.querySelector('#header-component');
const headerScrollRoot = document.querySelector('.page-wrapper');
if (fitnessHeader) {
  const update = () => fitnessHeader.toggleAttribute('data-hl-scrolled', document.body.dataset.hlTemplate !== 'index' || Math.max(window.scrollY,headerScrollRoot?.scrollTop || 0) > 24);
  window.addEventListener('scroll',update,{passive:true});
  headerScrollRoot?.addEventListener('scroll',update,{passive:true});
  update();
}
document.querySelector('[data-u-search]')?.addEventListener('submit',event => {
  const field=event.target.querySelector('[name="q"]');
  field.value=`${field.value.trim()} tag:catalog-uniforms -tag:catalog-fitness`;
});
document.addEventListener('keydown',event=>{
  if(event.key==='Escape')document.querySelectorAll('.u-header details[open]').forEach(details=>details.open=false);
});
let colorScrollCeiling=null;
document.addEventListener('pointerdown',event=>{
  if(!matchMedia('(max-width:749px)').matches || !event.target.closest('[data-hl-color-option],.u-option--color'))return;
  colorScrollCeiling=Math.max(window.scrollY,headerScrollRoot?.scrollTop || 0);
},{capture:true,passive:true});
document.addEventListener('change',event=>{
  if(!matchMedia('(max-width:749px)').matches || !event.target.closest('[data-hl-color-option],.u-option--color') || colorScrollCeiling===null)return;
  const ceiling=colorScrollCeiling;
  const keepPosition=()=>{
    if((headerScrollRoot?.scrollTop || 0)>ceiling+2)headerScrollRoot.scrollTo({top:ceiling,behavior:'instant'});
    if(window.scrollY>ceiling+2)window.scrollTo({top:ceiling,behavior:'instant'});
  };
  requestAnimationFrame(()=>requestAnimationFrame(keepPosition));
  setTimeout(keepPosition,120);
  setTimeout(keepPosition,350);
},{capture:true});
